import React from 'react'
import { Navigate } from 'react-router-dom'
import { hasActiveAdminSession } from '../utils/functions/auth'

const PrivateRoute = ({ children }) => {
  if (!hasActiveAdminSession()) {
    return <Navigate to='/admin' replace />
  }

  return children
}

export default PrivateRoute
